import { ActionType, createReducer } from 'typesafe-actions';

import * as actions from 'store/actions/faqs';
import Faq from 'models/Faq';

export const faqReducer = createReducer<Faq[], ActionType<typeof actions>>([]).handleAction(
  actions.getFaqs.success,
  (state, { payload }) => payload,
);
